import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { BoundingBox } from "./model";
//import { Transform } from "konva/lib/Util";

interface GridSetting {
    width: number;
    height: number;
    hide: boolean;
    color: ColorValue;
}
interface ToolbarState {
    covered: {
        left: number;
        right: number;
        top: number;
        bottom: number;
    }
}
interface InterfaceState {
    mousePosition: Point2d;
    mouseUnmodifiedPosition: Point2d;
    mousePositionSnap: Point2d | undefined;
    mouseOverMainContainer: Point2d | undefined;
    gridSettings: GridSetting;
    toolbarState: ToolbarState;
    viewport: ViewPort;
    // worldTransformationMatrix: Mat5;
    // zoom: number;
    // pos: Point;
}

const initialState: InterfaceState = {
    mousePosition: { x: 0, y: 0 },
    mouseUnmodifiedPosition: { x: 0, y: 0 },
    mousePositionSnap: { x: 0, y: 0 },
    gridSettings: {
        width: 1000,
        height: 1000,
        hide: false,
        color: '#c4c2c2'
        //...
    },
    toolbarState: {
        covered: {
            left: 50,
            right: 200,
            top: 100,
            bottom: 50,
        }
    },
    viewport: {
        min: { x: 0, y: 0 },
        max: { x: 2000, y: 2000 },
        scale: 1
    },
    mouseOverMainContainer: undefined,
    // worldTransformationMatrix: [[1, 0, 0, 0], [0, -1, 0, 0], [0, 0, 1, 0], [0, 0, 0, 1]], // the -1 is needed because of flipping the Y coordinate (model has Y facing up, canvas has it facing down)
    // zoom: 1,
    // pos: { x: 0, y: 0 },
}
export const interfaceSlice = createSlice({
    name: 'interface',
    initialState,
    reducers: {
        // setWorldTransformationMatrix: (state, action) => {
        //     console.log("payload", action.payload);
        //     state.worldTransformationMatrix = action.payload;
        // },
        // setZoom: (state, action) => {
        //     state.zoom = action.payload;
        // },
        // setPos: (state, action) => {
        //     state.pos = action.payload;
        // },
        interfaceMouseOverMainContainer: (state, action) => {
            state.mouseOverMainContainer = action.payload
        },
        setMouseUnmodifiedPosition: (state, action: PayloadAction<Point2d>) => {
            state.mouseUnmodifiedPosition = action.payload
        },
        setMousePosition: (state, action: PayloadAction<Point2d>) => {
            state.mousePosition = action.payload
        },
        setMousePositionSnap: (state, action: PayloadAction<Point2d | undefined>) => {
            state.mousePositionSnap = action.payload
        },
        setViewportSize: (state, action: PayloadAction<{ width: number, height: number }>) => {
            state.viewport.max.x = state.viewport.min.x + action.payload.width / state.viewport.scale;
            state.viewport.max.y = state.viewport.min.y + action.payload.height / state.viewport.scale;
        },
        setViewportScale: (state, action: PayloadAction<number>) => {
            console.log("YOOOM");

            state.viewport = { ...state.viewport, scale: action.payload }
        },
        setViewportBounds: (state, action: PayloadAction<ViewPort>) => {
            state.viewport.min = action.payload.min;
            state.viewport.max = action.payload.max;
            state.viewport.scale = action.payload.scale;
        },

        fitToScreen: (state, action: PayloadAction<BoundingBox>) => {
            // console.log(state.viewport.min.x);

            const coveredPixelsByUI = state.toolbarState.covered;
            const viewport = state.viewport;
            const contentBoundingbox = action.payload;
            // console.log("contentBoundingBox", contentBoundingbox);

            const scaledCoveredSpaceX = ((coveredPixelsByUI.left + coveredPixelsByUI.right) / viewport.scale) || 1;
            const scaledCoveredSpaceY = ((coveredPixelsByUI.top + coveredPixelsByUI.bottom) / viewport.scale) || 1;

            const contentBoxLengthX = (contentBoundingbox.max.x - contentBoundingbox.min.x);
            const contentBoxLengthY = (contentBoundingbox.max.y - contentBoundingbox.min.y);
            const contentBoxLengthXWithPadding = (contentBoundingbox.max.x - contentBoundingbox.min.x) * 1.1;
            const contentBoxLengthYWithPadding = (contentBoundingbox.max.y - contentBoundingbox.min.y) * 1.1;
            const dx = (contentBoxLengthXWithPadding - contentBoxLengthX) / 2;
            const dy = (contentBoxLengthYWithPadding - contentBoxLengthY) / 2;

            const viewX = state.viewport.max.x - state.viewport.min.x;
            const viewY = state.viewport.max.y - state.viewport.min.y;

            const screenX = state.viewport.max.x - state.viewport.min.x - scaledCoveredSpaceX;
            const screenY = state.viewport.max.y - state.viewport.min.y - scaledCoveredSpaceY;

            const ratioX = (contentBoxLengthXWithPadding / screenX) || 1;
            const ratioY = (contentBoxLengthYWithPadding / screenY) || 1;
            const ratioToUse = ratioX > ratioY ? ratioX : ratioY;
            // console.log("CONTENT", ratioX, ratioY, contentBoxLengthXWithPadding, contentBoxLengthYWithPadding);

            if (ratioX > ratioY) {
                console.log("x ratio is bigger then y")
                state.viewport.min.x = contentBoundingbox.min.x + coveredPixelsByUI.left;
                state.viewport.min.y = contentBoundingbox.min.y + contentBoxLengthYWithPadding / 2 - screenY / 2 * ratioToUse;
            } else {
                console.log("y ratio is bigger than x")
                state.viewport.min.x = contentBoundingbox.min.x + contentBoxLengthXWithPadding / 2 - screenX / 2 * ratioToUse;
                state.viewport.min.y = contentBoundingbox.min.y
            }

            // giving a padding to the content
            // const dx = state.viewport.max.x - state.viewport.min.x;
            // const dy = state.viewport.max.y - state.viewport.min.y;
            // state.viewport.min.x -= dx * 0.05;
            // state.viewport.max.x += dx * 0.05;
            // state.viewport.min.y -= dy * 0.05;
            // state.viewport.max.y += dy * 0.05;

            //Conpenstaion for the toolbar on left
            viewport.min.x -= coveredPixelsByUI.left / viewport.scale * ratioToUse + dx;
            //Conpenstaion for the toolbar on top
            viewport.min.y -= coveredPixelsByUI.top / viewport.scale * ratioToUse + dy;
            console.log(viewport.min.x, viewport.min.y);

            //Set new viewport coordinates max:
            state.viewport.max.y = state.viewport.min.y + (viewY) * ratioToUse;
            state.viewport.max.x = state.viewport.min.x + (viewX) * ratioToUse;
            state.viewport.scale /= (ratioToUse);

            // const newratioX = ((state.viewport.max.x - state.viewport.min.x) / screenX) || 1;
            // const newratioY = ((state.viewport.max.y - state.viewport.min.y) / screenY) || 1;
            // const newratioToUse = newratioX > newratioY ? newratioX : newratioY;
            // state.viewport.scale /= (newratioToUse);
        }
    }
})


export const {
    // setWorldTransformationMatrix,
    // setZoom,
    // setPos,
    interfaceMouseOverMainContainer,
    setMouseUnmodifiedPosition,
    setMousePosition,
    setMousePositionSnap,
    setViewportSize,
    setViewportScale,
    setViewportBounds,
    fitToScreen,
} = interfaceSlice.actions

export default interfaceSlice.reducer